import { OmniaModuleId } from "../../generated/enums";
import { getIconClass } from "../../utils/utils";

export class MenuItem {

    moduleId: OmniaModuleId

    icon: string

    shortName: string

    popupId: string

    beta: boolean

    constructor(
        public name: string,
        icon: string,
        public targetUrl: string = null,
        public items: MenuItem[] = [],
        public disabled: boolean = false) {

        this.icon = getIconClass(icon)

    }

}
